const mediaMentions = {
  displayField: 'title',
  name: 'Media Mentions',
  description: 'Links on other website of E&V',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'description',
      name: 'Description',
      type: 'Text',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'publicationLogo',
      name: 'Publication Logo',
      type: 'Link',
      localized: false,
      required: true,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'publicationDate',
      name: 'Publication Date',
      type: 'Date',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'url',
      name: 'URL',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [
        {
          regexp: {
            pattern: '^(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-/]))?$',
            flags: null
          }
        }
      ],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'mediaMentions',
    version: 2,
    updatedAt: '2023-10-23T19:54:20.876Z'
  }
};
export default mediaMentions;